module.exports = __webpack_public_path__ + "img/ESFJ.656d8ab2.png";